import { render, staticRenderFns } from "./TakipListView.vue?vue&type=template&id=674ce3c1"
import script from "./TakipListView.vue?vue&type=script&lang=ts"
export * from "./TakipListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports